




































import { Vue, Prop, Component } from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';
import { forEach } from 'lodash';
import { UnitsApi, Unit } from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import UnitInformation from '@/components/Form/Unit/UnitInformation/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import PageTitle from '@/components/PageTitle/index.vue';
import EmailExistsModal from '@/components/Modal/EmailExistsModal/index.vue';
import Format from '@/util/Format';
import PermissionMixin from '@/mixins/PermissionMixin';

@Component({
  components: {
    UnitInformation,
    PrimaryButton,
    TextButton,
    PageTitle,
    EmailExistsModal,
  },
  directives: { Sticky },
})
export default class CreateUnit extends mixins(PermissionMixin) {
  private loading: boolean = false;

  private lazy = false;

  private showEmailUseModal: boolean = false;

  public error: string = '';

  private unitInfo: any = {
    compassUnitId: '',
    name: '',
    scoutFirstID: this.userID,
    address: {
      address: '',
      city: '',
      state: '',
      zip: '',
      country: 'USA',
    },
    phone: {
      ext: '',
      phone: '',
    },
    active: true,
    marketId: '',
    sectorId: '',
    managerUserId: '',
    schedule: {
      numberOfStations: 1,
      autoSchedule: false,
      cuisineExclusions: [],
      restaurantExclusions: [],
      popupPattern: [1, 2, 3, 4, 5],
      rotationFrequency: 'weekly',
      weeklyOccurrence: [1, 2, 3, 4, 5],
      differentRotation: false,
    },
  };

  get userID() {
    return UserModule.userId;
  }

  public async onAddUnit() {
    if ((this.$refs.form as any).validate()) {
      try {
        this.loading = true;
        if (AppModule.isLoggedIn && AppModule.accessToken) {
          if (this.unitInfo.phone.phone) {
            const { phone } = this.unitInfo.phone;
            this.unitInfo.phone.phone = Format.CheckMaskNumber(phone);
          }
          if (this.unitInfo.phone.ext) {
            this.unitInfo.phone.ext = parseInt(this.unitInfo.phone.ext, 10);
          } else {
            this.unitInfo.phone.ext = Number(this.unitInfo.phone.ext);
          }
          if (this.unitInfo.compassUnitId) {
            this.unitInfo.compassUnitId = parseInt(this.unitInfo.compassUnitId, 10);
          }

          const unitData: Unit = {
            compassUnitId: this.unitInfo.compassUnitId,
            name: this.unitInfo.name,
            address: this.unitInfo.address,
            phone: this.unitInfo.phone,
            sectorId: this.unitInfo.sectorId,
            marketId: this.unitInfo.marketId,
            scoutUserId: this.unitInfo.scoutFirstID,
            managerUserId: this.unitInfo.managerUserId,
            active: this.unitInfo.active,
            schedule: this.unitInfo.schedule,
          };

          try {
            const api = new UnitsApi(AppModule.apiConfig);
            const unit = await api.createUnit(unitData);
            if (unit.data) {
              let message = 'unit name added';
              const { name } = unit.data;
              message = `${name} added`;
              this.$router.push({ name: 'units', params: { message } });
            }
          } catch (error) {
            throw error;
          }
        }
      } catch (err) {
        const { error } = err.response.data;
        this.error = error.message;
        if (err && err.error) {
          this.error = err.error;
          if (err.code === 409) {
            this.showEmailUseModal = true;
          }
        }
      }
      this.loading = false;
    } else {
      forEach((this.$refs.form as any).inputs, (e) => {
        if (e.hasError) {
          (document.getElementById(e.id) as HTMLDivElement).scrollIntoView();
          return false;
        }
        return true;
      });
    }
  }

  public onSaveExistsEmail() {
    this.showEmailUseModal = false;
  }

  // close the email modal error
  public onCancel() {
    this.showEmailUseModal = false;
  }

  // cancel the unit page
  public onClose() {
    this.$router.push('/units');
  }
}
